export default __webpack_public_path__ + "static/media/314.5bb777e9.png";